module.exports = __webpack_public_path__ + "img/failure.f9e58870.png";